import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SelectSearchDataComponent} from '../../../../../components/common/select-search-data/select-search-data.component';
import {UntypedFormGroup} from '@angular/forms';
import {Operator, UrlParameter} from '../../../../../shared/utils/url.builder';
import {SaleModel} from '../../entity/sale.model';
import {SaleSearchByPartnerIdService} from '../../../impl/service/SaleSearchByPartnerId.service';

@Component({
    selector: 'app-sale-search',
    templateUrl: './sale-search.component.html',
    providers: [SaleSearchByPartnerIdService]
})
export class SaleSearchComponent {

    @ViewChild('selectSearch') selectSearchComponent: SelectSearchDataComponent<SaleModel>;

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() placeHolder = 'Rechercher';
    @Input() noEntryPlaceHolder = 'Aucun résultat trouvé';
    @Input() directionValue;

    @Output() changeEvent = new EventEmitter<SaleModel>();


    constructor(public service: SaleSearchByPartnerIdService) {
    }


    get additionalUrlParameters(): UrlParameter[] {
        return this.directionValue ? [new UrlParameter('direction.value', this.directionValue, Operator.EQUALS)] : [];
    }

    getLabel(entity: SaleModel) {
        return entity.summary.partner.name + '-#' + entity.summary.id;
    }

    getSelectedElement(): SaleModel {
        return this.selectSearchComponent?.getSelectedElement();
    }

    change(entity: SaleModel) {
        if (this.changeEvent) {
            this.changeEvent.emit(entity);
        }
    }

    /* setValue(value: string, emitEvent = true): Promise<PartnerModel> {
      return new Promise<PartnerModel>((resolve, reject) => {
        this.selectSearchComponent?.setValue(value, emitEvent)
            .then(value1 => resolve(value1))
            .catch(reason => reject(reason));
      })
    } */

    entityLoaded(entity: SaleModel, emitEvent = true) {
        this.selectSearchComponent.entityLoaded(entity, emitEvent);
    }

}
